import React from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { useRecoilState } from 'recoil';
import { apiKeyAtom } from '../../App';
import DeeleeoTabs from '../../components/DeeleeoTabs';
import PageLayout from '../PageLayout';
import { DetailsContainer, Divider } from '../Shipment/ShipmentDetails';
import Cards from './components/Cards';
import PaymentForm from './components/PaymentForm';
import UserInfo from './components/UserInfo';
import { getCompanyInfo } from '../../redux/actions/userActions';
import { HtmlTooltip } from '../../components/InputField';
import InfoIcon from "../../assets/icons/Info-icon.svg";
import styled from 'styled-components'
import tw from 'twin.macro'

const SectionHeader = styled.div`
  ${tw`text-fontBlue mt-6 font-black`}
  font-size: 18px;
 
  
`

const AddPayment = (props) => {

    // eslint-disable-next-line no-unused-vars
    const { apiCode, userData, getCompanyInfo } = props;

    // eslint-disable-next-line no-unused-vars
    const [apiKey, setApiKey] = useRecoilState(apiKeyAtom);
    // setApiKey(apiCode);

  

    return (
        <PageLayout wider>
            <DeeleeoTabs selectedTab={3} />
            <Divider />
            <DetailsContainer>
                <SectionHeader>Account Info:  <span className='float-right'></span></SectionHeader>
                <UserInfo userData={userData} getCompanyInfo={getCompanyInfo} />
                {/* <Divider /> */}
                <SectionHeader>Current Credit Balance: ${userData.credit} <HtmlTooltip
                    style={{ marginLeft: 7 }}
                    placement="top"
                    title="Current Credit Balance reflects the amount of credit you have in your Deeleeo account. This credit amount will automatically be applied to future Deeleeos until the credit is all used up. When credit is at $0, payment will be charged to your account.">

                    <img
                        style={{ display: 'inline' }}
                        className="-mt-1 ml-1"
                        src={InfoIcon}
                        alt={"credit information"}
                    />
                </HtmlTooltip></SectionHeader>
                <Divider />
                <SectionHeader>Cards:</SectionHeader>
                <Divider />
                <Cards/>
                <SectionHeader>Add Payment Information:</SectionHeader>
                <Divider />
                <PaymentForm />                
            </DetailsContainer>
        </PageLayout>
    );
}

const mapStateToProps = state => ({   
    apiCode: state.userReducer.apiCode,
    userData: state.userReducer
})

const mapDispatchToProps = dispatch => ({
    getCompanyInfo: (api_key) => dispatch(getCompanyInfo(api_key)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddPayment));